import React from "react";
import { fetchBinsList } from "../../../redux/api/expedition.api";
import TableWidget from "../../../components/tables/TableWidget";
import {
  getViewCargoVolumeTableData,
  viewCargoVolumeTableHeader,
} from "./components/tableConfigs/viewCargoVolumeTableConfig";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

function ViewCargoVolume() {
  const dispatch = useAppDispatch();

  const {
    expedition: {
      nodeBins: { data, isLoading },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  const handleTableActions = (action: TableActions) => {
    if (action.tablePagination.page && action.tablePagination.rowsPerPage) {
      dispatch(
        fetchBinsList({
          nod: "Bucuresti*1",
        }),
      );
    }
  };

  //  useEffect(() => {
  //    return () => {
  //      dispatch(clearCargoNode());
  //    };
  //  }, [dispatch]);

  return (
    <TableWidget
      tableTitle={`Cargo`}
      tableHeaderData={viewCargoVolumeTableHeader}
      tableItemsData={getViewCargoVolumeTableData(data)}
      tableLoading={isLoading}
      handleTableActions={handleTableActions}
      borderedRow
      withTablePagination={false}
    />
  );
}

export default ViewCargoVolume;
